var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-lighter full-view content-center mt-5"},[_c('h1',[_vm._v("Page not found page")])])
}]

export { render, staticRenderFns }